import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { sendAnalyticsEvents } from '../../analytics/common'
import { EVENTS } from '../../analytics/events'
import { useTranslation } from 'react-i18next'
import { selectEventsData } from '../events/eventsSlice'
import { selectPaymentSettingsStatus } from '../signup/signupSlice';
import CreatingProfileUI from '../../UI/CreatingProfileUI'
import { appendLinksList } from '../../helper/utils'
import MainHeadline from '../../UI/MainHeadline'
import MainDescription from '../../UI/MainDescription'


const CreatingProfile = ({ history }) => {
    const { t } = useTranslation();
    const eventsData = useSelector(selectEventsData);
    const settingsStatus = useSelector(selectPaymentSettingsStatus);

    useEffect(() => {
        appendLinksList('plans');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);

    useEffect(() => sendAnalyticsEvents(EVENTS.onboardingCreatingProfile, eventsData), [eventsData]);

    const doneCallback = () => {
      if (!settingsStatus) return;
      history.push('/checkout');
    }

    return (
        <>
            <div>
                <MainHeadline customStyles={'margin-top: min(32px,3vh);'}>{t('creating_your_profile')}</MainHeadline>
                <MainDescription>{t('creating_description')}</MainDescription>
            </div>
            <CreatingProfileUI doneCallback={doneCallback} eventsData={eventsData} />
        </>
    )
};

export default CreatingProfile